module.exports = __webpack_public_path__ + "img/HomePage-agencies.ca22093.webp";